import { fetchAdmins } from "../../mp-core/redux/actions/assessmentActions"
import { AccountType, Educator } from "../../mp-database"
import { fetchCreators } from "./fetchCreators"

type WhereOption = [string, string, any]

export interface SearchData {
  id: string
  collection?: string
  searchField?: string
  accountType?: AccountType
  fetchSuperAdmin?: boolean
  fetchDistrictAdmins?: boolean
  whereOptions?: WhereOption[]
}

export const fetchUsers = async (searchData: SearchData) => {
  const users = Object.values(await fetchAdmins(searchData)) as Educator[]

  return fetchCreators<Educator>(users)
}
